import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function ArticlesLies() {
  const { t } = useTranslation('blogsignes');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section ref={ref} className="bg-soft-gray py-12 md:py-16">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-10">
        <h2 className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl mb-8 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          {t('lies_h2')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <a
            href="/blog/prix-toiture-levis-2026"
            onClick={(e) => { e.preventDefault(); if (window.REACT_APP_NAVIGATE) window.REACT_APP_NAVIGATE('/blog/prix-toiture-levis-2026'); }}
            className={`bg-white rounded-xl p-5 text-left transition-all duration-700 hover:shadow-md block ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: '150ms' }}
          >
            <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-2">
              {t('lie_1_title')}
            </h3>
            <p className="text-slate-primary/50 text-sm mb-4">{t('lie_1_desc')}</p>
            <span className="text-copper text-sm font-semibold flex items-center gap-1">
              Lire <i className="ri-arrow-right-line" aria-hidden="true" />
            </span>
          </a>

          <a
            href="/blog/comment-choisir-couvreur-levis"
            onClick={(e) => { e.preventDefault(); if (window.REACT_APP_NAVIGATE) window.REACT_APP_NAVIGATE('/blog/comment-choisir-couvreur-levis'); }}
            className={`bg-white rounded-xl p-5 text-left transition-all duration-700 hover:shadow-md block ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: '250ms' }}
          >
            <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-2">
              {t('lie_2_title')}
            </h3>
            <p className="text-slate-primary/50 text-sm mb-4">{t('lie_2_desc')}</p>
            <span className="text-copper text-sm font-semibold flex items-center gap-1">
              Lire <i className="ri-arrow-right-line" aria-hidden="true" />
            </span>
          </a>

          <div
            className={`bg-white rounded-xl p-5 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: '350ms' }}
          >
            <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-2">
              {t('lie_3_title')}
            </h3>
            <p className="text-slate-primary/50 text-sm mb-4">{t('lie_3_desc')}</p>
            <span className="text-copper text-sm font-semibold flex items-center gap-1 opacity-60">
              À venir <i className="ri-arrow-right-line" aria-hidden="true" />
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}